import {
	Box,
	Button,
	ButtonBase,
	Checkbox,
	Grid2,
	InputBase,
	Typography,
} from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EyeIcon, HideEyeIcon } from '../assets/icons/Icons';
import { MAIN_THEME_COLOR } from '../assets/theme/Colors';
import { helperText } from '../assets/theme/Theme';
import {
	getRememberMe,
	setAccessToken,
	setRememberMe,
} from '../Utils/AuthUtil';

const initialErrorState = {
	status: false,
	msg: '',
};

function Login() {
	const navigator = useNavigate();
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [remember, setRemember] = useState(0);
	const [emailError, setEmailError] = useState(initialErrorState);
	const [passwordError, setPasswordError] = useState(initialErrorState);
	const [loginStatus, setLoginStatus] = useState(initialErrorState);
	const [show, setShow] = useState(false);

	function onChangeEmail(
		event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
	) {
		setEmailError(initialErrorState);
		setEmail(event.target.value);
	}

	function onChangePassword(
		event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
	) {
		setPasswordError(initialErrorState);
		setPassword(event.target.value);
	}

	async function logIn() {
		let error = false;
		if (!email || email === '') {
			setEmailError({ status: true, msg: 'Email is Required.' });
			error = true;
		}

		if (email !== '' && email.indexOf('@') === -1) {
			setEmailError({ status: true, msg: 'Invalid Email' });
			error = true;
		}

		if (!password || password === '') {
			setPasswordError({ status: true, msg: 'Password is Required.' });
			error = true;
		}

		if (error) {
			return;
		} else {
			setLoginStatus(initialErrorState);
			if (email === 'dtbot@gmail.com' && password === 'bot123#') {
				navigator('/chats');
				setAccessToken('cf8ca23f-a0bc-42ef-ae68-9a959bec877c');
			} else {
				setLoginStatus({
					status: true,
					msg: 'Email or password is incorrect',
				});
			}
		}
	}

	const onChangeRememberMe = () => {
		const val: number = Number(getRememberMe());
		if (val === 0 || val === 2) {
			setRemember(1);
			setRememberMe('1');
		}
		if (val === 1) {
			setRemember(0);
			setRememberMe('0');
		}
	};

	return (
		<Box
			sx={{
				position: 'relative',
				minHeight: '100vh',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				px: { xs: 1.5, sm: 3 },
				py: { xs: 1.5, sm: 3 },
				overflow: 'hidden',
				background:
					'radial-gradient(circle at 8% 8%, rgba(32, 177, 145, 0.14), transparent 29%), radial-gradient(circle at 96% 90%, rgba(0, 128, 105, 0.1), transparent 30%), #F5F8F7',
			}}>
			<Box
				sx={{
					width: '100%',
					maxWidth: 1060,
					minHeight: { md: 620 },
					display: 'grid',
					gridTemplateColumns: { xs: '1fr', md: '1.08fr 0.92fr' },
					border: '1px solid rgba(15, 67, 57, 0.1)',
					borderRadius: { xs: '20px', sm: '26px' },
					overflow: 'hidden',
					backgroundColor: '#FFFFFF',
					boxShadow: '0 28px 72px rgba(15, 57, 48, 0.16)',
				}}>
				<Box
					sx={{
						display: { xs: 'none', md: 'flex' },
						position: 'relative',
						flexDirection: 'column',
						justifyContent: 'space-between',
						p: { md: 5, lg: 6 },
						overflow: 'hidden',
						background:
							'linear-gradient(145deg, #073C35 0%, #075F51 58%, #008A72 100%)',
						'&::before': {
							content: '""',
							position: 'absolute',
							width: 420,
							height: 420,
							borderRadius: '50%',
							right: -160,
							bottom: -190,
							border: '1px solid rgba(255,255,255,0.13)',
							boxShadow:
								'0 0 0 54px rgba(255,255,255,0.045), 0 0 0 108px rgba(255,255,255,0.035)',
						},
						'&::after': {
							content: '""',
							position: 'absolute',
							width: 180,
							height: 180,
							borderRadius: '50%',
							top: -88,
							right: 46,
							backgroundColor: 'rgba(172, 244, 223, 0.1)',
						},
					}}>
					<Box
						sx={{
							position: 'relative',
							zIndex: 1,
						}}>
						<Grid2 container alignItems="center" gap={1.25}>
							<Box
								sx={{
									width: 42,
									height: 42,
									borderRadius: '13px',
									backgroundColor: '#FFFFFF',
									color: '#007A66',
									display: 'grid',
									placeItems: 'center',
									fontSize: '13px',
									fontWeight: 900,
									letterSpacing: '-0.5px',
								}}>
								CM
							</Box>
							<Typography
								fontSize="15px"
								fontWeight={800}
								color="#FFFFFF">
								SenzMate
							</Typography>
						</Grid2>
					</Box>

					<Box
						sx={{
							position: 'relative',
							zIndex: 1,
							maxWidth: 430,
						}}>
						<Typography
							fontSize={{ md: '34px', lg: '42px' }}
							lineHeight={1.12}
							letterSpacing="-1.4px"
							fontWeight={750}
							color="#FFFFFF">
							Conversations,
							<br />
							with clarity.
						</Typography>
						<Typography
							fontSize="15px"
							lineHeight={1.7}
							color="rgba(238, 255, 251, 0.76)"
							mt={2.25}>
							A focused workspace for the people behind your
							website bot. Review conversations and keep your
							knowledge current in one place.
						</Typography>
					</Box>

					<Box
						sx={{
							position: 'relative',
							zIndex: 1,
							display: 'flex',
							alignItems: 'center',
							gap: 1,
							color: 'rgba(238, 255, 251, 0.72)',
							fontSize: '12px',
							fontWeight: 600,
						}}>
						<Box
							sx={{
								width: 8,
								height: 8,
								borderRadius: '50%',
								backgroundColor: '#83F0D0',
								boxShadow:
									'0 0 0 4px rgba(131, 240, 208, 0.14)',
							}}
						/>
						Private workspace · Secure access
					</Box>
				</Box>

				<Box
					component="section"
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						p: { xs: 3, sm: 5, md: 5.5, lg: 6 },
						backgroundColor: '#FFFFFF',
					}}>
					<Box sx={{ width: '100%', maxWidth: 390 }}>
						<Box
							sx={{ display: { xs: 'flex', md: 'none' }, mb: 4 }}>
							<Grid2 container alignItems="center" gap={1.1}>
								<Box
									sx={{
										width: 38,
										height: 38,
										borderRadius: '12px',
										backgroundColor: '#E8F7F2',
										color: '#007A66',
										display: 'grid',
										placeItems: 'center',
										fontSize: '12px',
										fontWeight: 900,
									}}>
									CM
								</Box>
								<Typography
									fontSize="15px"
									fontWeight={800}
									color="#12362F">
									SenzMate Website Bot
								</Typography>
							</Grid2>
						</Box>

						<Typography
							fontSize={{ xs: '26px', sm: '29px' }}
							lineHeight={1.15}
							letterSpacing="-0.7px"
							fontWeight={750}
							color="#102A25">
							Welcome back
						</Typography>
						<Typography
							fontSize="14px"
							lineHeight={1.6}
							color="#6A7D78"
							mt={1}
							mb={3.5}>
							Sign in to manage your website bot conversations.
						</Typography>

						<Typography
							fontSize="12px"
							fontWeight={700}
							color="#2C4540"
							mb={0.9}>
							Email
						</Typography>
						<Grid2
							container
							alignItems="center"
							sx={{
								minHeight: 50,
								px: 1.75,
								backgroundColor: '#FBFCFC',
								border: `1px solid ${emailError.status ? '#D32F2F' : '#D9E4E1'}`,
								borderRadius: '10px',
								transition:
									'border-color 160ms ease, box-shadow 160ms ease',
								'&:focus-within': {
									borderColor: emailError.status
										? '#D32F2F'
										: MAIN_THEME_COLOR,
									boxShadow: emailError.status
										? '0 0 0 3px rgba(211, 47, 47, 0.08)'
										: '0 0 0 3px rgba(0, 128, 105, 0.12)',
								},
							}}>
							<InputBase
								type="email"
								placeholder="name@company.com"
								sx={{
									flex: 1,
									fontSize: '14px',
									color: '#102A25',
								}}
								error={emailError.status}
								onChange={onChangeEmail}
								onKeyPress={event =>
									event.code === 'Enter' && logIn()
								}
							/>
						</Grid2>
						<Typography
							sx={{ ...helperText, minHeight: 22, pl: 0 }}>
							{emailError.msg}
						</Typography>

						<Typography
							fontSize="12px"
							fontWeight={700}
							color="#2C4540"
							mb={0.9}>
							Password
						</Typography>
						<Grid2
							container
							alignItems="center"
							wrap="nowrap"
							sx={{
								minHeight: 50,
								px: 1.75,
								backgroundColor: '#FBFCFC',
								border: `1px solid ${passwordError.status ? '#D32F2F' : '#D9E4E1'}`,
								borderRadius: '10px',
								transition:
									'border-color 160ms ease, box-shadow 160ms ease',
								'&:focus-within': {
									borderColor: passwordError.status
										? '#D32F2F'
										: MAIN_THEME_COLOR,
									boxShadow: passwordError.status
										? '0 0 0 3px rgba(211, 47, 47, 0.08)'
										: '0 0 0 3px rgba(0, 128, 105, 0.12)',
								},
							}}>
							<InputBase
								type={show ? 'text' : 'password'}
								placeholder="Enter your password"
								sx={{
									flex: 1,
									minWidth: 0,
									fontSize: '14px',
									color: '#102A25',
								}}
								error={passwordError.status}
								onChange={onChangePassword}
								onKeyPress={event =>
									event.code === 'Enter' && logIn()
								}
							/>
							<ButtonBase
								aria-label={
									show ? 'Hide password' : 'Show password'
								}
								onClick={() => setShow(!show)}
								sx={{ p: 0.5, borderRadius: '8px' }}>
								{show ? (
									<HideEyeIcon error={passwordError.status} />
								) : (
									<EyeIcon error={passwordError.status} />
								)}
							</ButtonBase>
						</Grid2>
						<Typography
							sx={{ ...helperText, minHeight: 22, pl: 0 }}>
							{passwordError.msg}
						</Typography>

						<Grid2 container alignItems="center" sx={{ mt: 0.25 }}>
							<Checkbox
								size="small"
								sx={{ p: 0.25, color: '#91A39E' }}
								onChange={onChangeRememberMe}
								checked={remember !== 0}
							/>
							<Typography
								fontSize="12px"
								color="#6A7D78"
								ml={0.65}>
								Remember me
							</Typography>
						</Grid2>

						{loginStatus.status && (
							<Typography
								fontSize="12px"
								color="#B42318"
								textAlign="center"
								mt={1.5}
								sx={{
									px: 1.25,
									py: 0.9,
									borderRadius: '8px',
									backgroundColor: '#FFF2F1',
								}}>
								{loginStatus.msg}
							</Typography>
						)}

						<Button
							onClick={logIn}
							variant="contained"
							fullWidth
							sx={{
								mt: 2.5,
								height: 50,
								backgroundColor: '#007B67',
								boxShadow:
									'0 10px 18px rgba(0, 123, 103, 0.18)',
								borderRadius: '10px',
								fontSize: '14px',
								fontWeight: 750,
								textTransform: 'none',
								'&:hover': {
									backgroundColor: '#006A59',
									boxShadow:
										'0 12px 22px rgba(0, 123, 103, 0.23)',
								},
							}}>
							Continue to workspace
						</Button>
						<Typography
							textAlign="center"
							fontSize="11px"
							color="#91A39E"
							mt={2.5}>
							SenzMate Website Bot · Conversation Manager
						</Typography>
					</Box>
				</Box>
			</Box>
		</Box>
	);
}

export default Login;
